import { createAction, props } from '@ngrx/store';
import { GBMConversationItemModel } from '../models/GBMessage.model';
import { LeadModel } from '../models/Lead.model';
import { MessageSource, MESSAGE_TYPE } from '../models/Message.model';
import { ReviewModel } from '../models/Review.model';

export enum MessagesActionTypes {
  filterMessagesByReadStatusBegin = '[Messages] Filter message by Read Status begin',
  filterMessagesByReadStatusSuccess = '[Messages] Filter message success',

  filterMessagesBySourceBegin = '[Messages] Filter message by Source begin',
  filterMessagesSourceSuccess = '[Messages] Filter message by Source success',

  sortMessagesByDateBegin = '[Messages] Sort message by Date begin',
  sortMessagesByDateSuccess = '[Messages] Sort message by Date success',

  selectConversation = '[Messages] Select conversation',
  selectMessage = '[Messages] Select message',

  clearConversationSuccessErrorData = '[Messages] Clear Conversation Success Error Data',
}

// FILTERING
export const filterMessagesByReadStatusBeginAction = createAction(
  MessagesActionTypes.filterMessagesByReadStatusBegin,
  props<{ messageType: MESSAGE_TYPE }>()
);

export const filterMessagesByReadStatusSuccessAction = createAction(
  MessagesActionTypes.filterMessagesByReadStatusSuccess,
  props<{
    payload: (GBMConversationItemModel & LeadModel & ReviewModel)[];
  }>()
);

export const filterMessagesBySourceBeginAction = createAction(
  MessagesActionTypes.filterMessagesBySourceBegin,
  props<{ sorting: 'ASC' | 'DESC'; sources: MessageSource[] }>()
);

export const filterMessagesBySourceSuccessAction = createAction(
  MessagesActionTypes.filterMessagesSourceSuccess,
  props<{
    sorting: 'ASC' | 'DESC';
    sources: MessageSource[];
    sortedMessages: (GBMConversationItemModel & LeadModel & ReviewModel)[];
    filteredMessages: (GBMConversationItemModel & LeadModel & ReviewModel)[];
  }>()
);

export const selectMessageAction = createAction(
  MessagesActionTypes.selectMessage,
  props<{ messageId: number }>()
);

export const selectConversationAction = createAction(
  MessagesActionTypes.selectConversation,
  props<{ conversationId: string | number }>()
);

// ----------------------------------------------------------------
export const clearConversationSuccessErrorDataAction = createAction(
  MessagesActionTypes.clearConversationSuccessErrorData
);
